import z from "zod"

export const CapabilityRequirementType = {
  INTEGRATION: "integration",
  CAPABILITY: "capability",
} as const

export type CapabilityRequirementType =
  (typeof CapabilityRequirementType)[keyof typeof CapabilityRequirementType]

export const CapabilityIntegrationRequirement = {
  SHOPIFY: "shopify",
  BIGBLUE: "bigBlue",
  REVENI: "reveni",
  AMPHORA: "amphora",
  LOOP_RETURNS: "loopReturns",
  REVER: "rever",
} as const

export type CapabilityIntegrationRequirement =
  (typeof CapabilityIntegrationRequirement)[keyof typeof CapabilityIntegrationRequirement]

export const CapabilityRequirementSchema = z.object({
  type: z.enum([CapabilityRequirementType.INTEGRATION, CapabilityRequirementType.CAPABILITY]),
  identifier: z.string(), // The specific thing required (e.g., "shopify", "getOrderTracking")
})

export const CapabilityMissingRequirementsSchema = z.object({
  result: z.literal(false),
  missingRequirements: z.array(CapabilityRequirementSchema),
})

export const CapabilityEnabledSchema = z.object({
  result: z.literal(true),
})

export const CapabilityEnablementResultSchema = z.discriminatedUnion("result", [
  CapabilityEnabledSchema,
  CapabilityMissingRequirementsSchema,
])

export type CapabilityRequirement = z.infer<typeof CapabilityRequirementSchema>
export type CapabilityMissingRequirementsResult = z.infer<
  typeof CapabilityMissingRequirementsSchema
>
export type CapabilityEnabledResult = z.infer<typeof CapabilityEnabledSchema>
export type CapabilityEnablementResult = z.infer<typeof CapabilityEnablementResultSchema>
